<template>
    <div v-if="isLoaded">
        <div class="row">
            <div class="col-md-12 mb-2">
                <router-link :to="{name: 'componentUpdate'}" class="btn btn-success btn-sm">{{$t('global.Update')}}
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-6">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-4">
                                    <b>Nummer</b>
                                </div>
                                <div class="col-8">
                                    {{component.number}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <b>Pakket</b>
                                </div>
                                <div class="col-8">
                                    {{component.packet_number}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <b>Klant</b>
                                </div>
                                <div class="col-8">
                                    {{component.relations.customer.name}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <b>Type</b>
                                </div>
                                <div class="col-8">
                                    {{component.relations.type.name}}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-5">
                                    <b>Controle</b>
                                </div>
                                <div class="col-7">
                                    {{component.interval_control}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-5">
                                    <b>Brand</b>
                                </div>
                                <div class="col-7">
                                    {{component.relations.brand.name}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-5">
                                    <b>Max. slijtage</b>
                                </div>
                                <div class="col-7">
                                    {{component.max_wear_rate}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-5">
                                    <b>Max. vervuiling</b>
                                </div>
                                <div class="col-7">
                                    {{component.max_pollution_rate}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-5">
                                    <b>Note</b>
                                </div>
                                <div class="col-7">
                                    {{component.note}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="row">
            <div class="col-6" v-if="component.type == 1">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <legend>Pollution</legend>
                            <rate typeChart="pollution" :chartData="component.chart_data" :component="component"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="col-6" v-if="component.type == 1">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <legend>Wear</legend>
                            <rate typeChart="wear" :chartData="component.chart_data" :component="component"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="row">
            <div class="col-12" v-if="component.type == 2">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <legend>Flame arrestor</legend>
                            <flame-arrestor :chartData="component.chart_data" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
    import FlameArrestor from "../../components/charts/flame-arrestor.vue";
    import Rate from "../../components/charts/rate.vue";

    export default {
        data() {
            return {
                isLoaded: false,
                component: {}
            }
        },
        components: {
            FlameArrestor,
            Rate
        },
        mounted() {
            this.loadFormData()
        },
        methods: {
            async loadFormData() {
                let component = await this.$store.dispatch('GET_COMPONENT', {
                    id: this.$route.params.id,
                    customer_id: this.$route.params.customer_id
                })
                this.isLoaded = true

                this.component = component
            }
        }
    }
</script>
